<p-orderList [value]="ambientes"
             i18n-header
             header="Ambientes"
             filterBy="descricao"
             filter="filter"
             i18n-filterPlaceholder
             filterPlaceholder="Buscar ambiente..."
             [metaKeySelection]="false"
             [(selection)]="ambientesSel"
             (onSelectionChange)="selecionarAmbiente(ambientesSel)">
  <ng-template let-ambiente pTemplate="item">
    <div class="ui-helper-clearfix">
      <img src="assets/images/home.png" style="display:inline-block;margin:2px 0 2px 2px" width="48" />
      <div style="font-size:14px;float:right;margin:15px 5px 0 0" >
        {{ambiente.descricao}}
      </div>
    </div>
  </ng-template>
</p-orderList>
